import { Navigate, useParams } from "react-router-dom";
import { getIndustry, industryPath } from "@/data/industries";

/** Old URL: /internships/:categoryId  ->  /industries/:industryId (unknown ids go to programmes). */
export default function LegacyInternshipRedirect() {
  const { categoryId } = useParams();
  const industry = getIndustry(categoryId);

  if (!industry) return <Navigate to="/programs" replace />;
  return <Navigate to={industryPath(industry.id)} replace />;
}
